import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function FeaturedRotator({ items, onNavigate }) {
    const [idx, setIdx] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (paused || !items || items.length < 2) return;
        const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 5000);
        return () => clearInterval(t);
    }, [paused, items]);

    if (!items || items.length === 0) return null;
    const item = items[idx];

    return (
        <div
            className="flex h-full flex-col justify-between bg-navy p-8 text-white"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            data-testid="mega-featured-rotator"
        >
            <div className="min-h-[10.5rem]">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={idx}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -12 }}
                        transition={{ duration: 0.35, ease: EASE }}
                    >
                        <p className="eyebrow-light">{item.eyebrow}</p>
                        <p className="mt-4 font-display text-lg font-semibold leading-snug">{item.title}</p>
                        {item.body && (
                            <p className="mt-3 text-[13px] leading-relaxed text-white/55">{item.body}</p>
                        )}
                    </motion.div>
                </AnimatePresence>
            </div>
            <div>
                <Link
                    to={item.to}
                    onClick={onNavigate}
                    className="link-underline !text-white"
                    data-testid="mega-featured-link"
                >
                    {item.cta}
                </Link>
                {items.length > 1 && (
                    <div className="mt-6 flex gap-2" role="tablist" aria-label="Featured items">
                        {items.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setIdx(i)}
                                aria-label={`Show featured item ${i + 1}`}
                                aria-selected={i === idx}
                                role="tab"
                                data-testid={`mega-featured-tick-${i + 1}`}
                                className={`h-0.5 w-8 transition-colors duration-300 ${
                                    i === idx ? "bg-blue-bright" : "bg-white/25 hover:bg-white/50"
                                }`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
